import { SalesSupportPerson } from "src/api-service";

// **************************************************************************
// SALES SUPPORT PERSON STATE
// **************************************************************************
export interface SalesSupportPersonState {
    salesSupportPerson: SalesSupportPerson | null;
    salesSupportPersons: SalesSupportPerson[];
    salesSupportPersonsLoading: boolean;
}

export const initialSalesSupportPersonState: SalesSupportPersonState = {
    salesSupportPerson: null,
    salesSupportPersons: [],
    salesSupportPersonsLoading: false,
};
